// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"306":"3a23258da002db85","888":"0781072181858a2d"}[chunkId] + ".css";
};